import { html } from "lit";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfClickOutside = class extends BaseComponent {
  constructor() {
    super();
    this.disabled = false;
    this.addEventListener("mouseout", this.handleMouseOut);
  }
  handleClick(e) {
    if (!this.disabled && !(e == null ? void 0 : e.composedPath().includes(this))) {
      this.emit(
        {
          name: "click-outside",
          payload: e.target
        },
        { bubbles: false }
      );
    }
  }
  isEqualOrParentOf(parent, child) {
    if (parent === child) {
      return true;
    }
    let node = child.parentNode;
    while (node !== null) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }
  handleMouseOut(event) {
    var _a;
    const eventTarget = event.relatedTarget;
    const currentHost = (_a = this.getRootNode()) == null ? void 0 : _a.host;
    if (!currentHost || !eventTarget) {
      return;
    }
    if (this.isEqualOrParentOf(currentHost, eventTarget) || this.isEqualOrParentOf(this, eventTarget)) {
      return;
    }
    this.emit("mouse-outside");
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleClick = this.handleClick.bind(this);
    document.addEventListener("mousedown", this.handleClick);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("mousedown", this.handleClick);
  }
  render() {
    return html`<slot></slot>`;
  }
};
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfClickOutside.prototype, "disabled", 2);
DsfClickOutside = __decorateClass([
  defineElement("dsf-click-outside")
], DsfClickOutside);
export {
  DsfClickOutside
};
